import { ProjectChild } from "shared/types/Project"

import { useProjectChildMultiActionCallbacks } from "entities/projects/model/useProjectChildMultiActionCallbacks"
import { useProjectPermissions } from "entities/projects/model/useProjectPermissions"
import { useProjectRequestMonitor } from "entities/projects/model/useProjectRequestState"
import { TeamRole } from "entities/team-members/types/TeamRole"

import { ProjectChildMultiSelectSidebarModel } from "../ProjectChildMultiSelectSidebar"

export interface UseProjectChildMultiSelectSidebarModelArgs {
  projectID: string
  selectedChildren: ProjectChild[]
}

export function useProjectChildMultiSelectSidebarModel({
  projectID,
  selectedChildren
}: UseProjectChildMultiSelectSidebarModelArgs): ProjectChildMultiSelectSidebarModel {
  const { isUpdatingChildren } = useProjectRequestMonitor({ projectID })
  const callbacks = useProjectChildMultiActionCallbacks({
    projectID,
    projectChildren: selectedChildren
  })
  const { role } = useProjectPermissions({ projectID })

  return {
    selectedChildren,
    callbacks,
    isDisabled: isUpdatingChildren,
    hideControls: role === TeamRole.READ
  }
}
